import React from 'react';

import { type ComponentsConfig, Control, Option } from 'app/widgets/Dropdown/Single';

export type SearchOption = {
  label: string;
  value: number;
};

function DropdownComponents(): ComponentsConfig<SearchOption> {
  return ({
    Control: (props) => (
      <Control {...props}
               customInnerProps={{
                 ['data-ga-event']: props.menuIsOpen ? 'search-sportFilter' : null,
               }}>
        {props.children}
      </Control>
    ),
    Option: (props) => (
      <Option {...props}
              customInnerProps={{
                ['data-ga-event']: 'search-sportFilterSelect',
                ['data-ga-sport-category']: props.data.value,
              }}>
        {props.children}
      </Option>
    ),
  });
}

export default DropdownComponents;
